function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "edit"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m21.1430664 4.0585938-.171875-.171875c-1.1538086-1.1533203-3.0888672-1.1542969-4.2421875 0l-8.5859375 8.5859375c-.128418.1279297-.2192383.2890625-.2631836.4648438l-1 4c-.1787109.7167969.4936523 1.3945313 1.2128906 1.2119141l4-1c.1757813-.0439453.3364258-.1347656.4643555-.2626953l8.5859375-8.5859375c1.1542969-1.1533205 1.1542969-3.0888673 0-4.2421876zm-9.8041992 11.2177734-2.1142578.5292969.5283203-2.1142578 5.597168-5.5976563 1.5859375 1.5859375zm8.3901367-8.3896484-1.3789062 1.3789062-1.5859375-1.5859375 1.3789063-1.3789063c.3740234-.3730469 1.0400391-.3730469 1.4140625 0l.171875.171875c.3833007.3837891.3833007 1.0302735-.0000001 1.4140626z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17 15c-.5522461 0-1 .4472656-1 1v4h-12v-16h10c.5522461 0 1-.4472656 1-1s-.4477539-1-1-1h-10c-1.1030273 0-2 .8974609-2 2v16c0 1.1025391.8969727 2 2 2h12c1.1030273 0 2-.8974609 2-2v-4c0-.5527344-.4477539-1-1-1z"
})));

var Svg043Edit = function Svg043Edit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg043Edit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/043-edit.e866cb4d.svg";
export { ForwardRef as ReactComponent };